import * as React from 'react';
import { ProductCoverageViewModel } from '@models/Product';
import { RouteComponentProps } from 'react-router';
import { SpinnerPage } from '@common/components';
import ReactTable, { Column } from 'react-table';
import { CoverageOption } from '@models/CoverageOption';

export interface RenewalOptionsComponentProperties extends RouteComponentProps<{ id: number }> {
  readonly getRenewalOptions: (
    contractId: number,
    pageNumber: number,
    pageSize: number,
    orderBy: string,
    orderDirection: string
  ) => void;
  readonly message: string;
  readonly searchLoading: boolean;
  readonly searchPageNumber: number;
  readonly searchPageSize: number;
  readonly searchPageCount: number;
  readonly searchResults: ProductCoverageViewModel[];
  readonly searchResultsTotalCount: number;
}

export class RenewalOptionsComponent extends React.Component<RenewalOptionsComponentProperties> {
  isInitialized: boolean = false;
  componentDidMount() {
    if (this.props.match && this.props.match.params.id) {
      this.handleSearch(this.props.match.params.id);
    }
  }

  render() {
    let columns: Column[] = [
      {
        accessor: 'name',
        Header: 'Product',
        sortable: true
      },
      {
        accessor: 'value',
        Header: 'Description',
        sortable: false
      }
    ];

    let columnsChildren: Column[] = [
      {
        accessor: 'value',
        Header: 'Coverage',
        sortable: true
      },
      {
        accessor: (co: CoverageOption) => (co.isBasicCoverage ? 'Basic' : 'Normal Option'),
        id: 'isBasicCoverage',
        Header: 'Type',
        sortable: true
      },
      {
        accessor: (co: CoverageOption) => (co.price ? '$' + co.price.toFixed(2) : '---'),
        id: 'price',
        Header: 'Price',
        sortable: true
      }
    ];
    if (!this.props.searchResults || this.props.searchResults.length < 1) {
      return <SpinnerPage />;
    }
    return (
      <>
        <h1>Renewal Options</h1>
        {this.props.searchResults ? (
          <div>
            {this.props.searchResults && this.props.searchResults.length > 0 ? (
              <ReactTable
                onPageChange={() => {
                  Array.from(document.getElementsByClassName('rt-tbody')).forEach(element => {
                    element.scrollTop = 0;
                  });
                }}
                className="-striped -highlight"
                columns={columns}
                data={this.props.searchResults}
                defaultPageSize={10}
                loading={this.props.searchLoading}
                manual={true}
                onFetchData={this.handleFetchData}
                pages={this.props.searchPageCount}
                SubComponent={row => {
                  return (
                    <div style={{ padding: '20px' }}>
                      <ReactTable
                        data={row.original.coverages}
                        columns={columnsChildren}
                        defaultPageSize={row.original.coverages.length}
                        showPagination={false}
                      />
                    </div>
                  );
                }}
              />
            ) : (
              <h3>No renewal products available</h3>
            )}
          </div>
        ) : (
          ''
        )}
      </>
    );
  }
  private handleFetchData = (state: {
    page: number;
    pageSize: number;
    sorted: Array<{ id: string; desc: boolean }>;
  }): void => {
    if (this.isInitialized) {
      this.props.getRenewalOptions(this.props.match.params.id, state.page + 1, state.pageSize, '', 'asc');
    }
    this.isInitialized = true;
  };

  private handleSearch = (contractId: number): void => {
    this.isInitialized = true;
    this.props.getRenewalOptions(contractId, 1, this.props.searchPageSize, '', 'asc');
  };
}



// WEBPACK FOOTER //
// ./src/renewal/_components/renewal-options/renewal-options.component.tsx